import React from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import useAppSelector from "../../hooks/useAppSelector";

interface IStripeElementsProps {
    children: React.ReactNode;
}

const StripeElements: React.FC<IStripeElementsProps> = ({children}) => {

    const {gateway, error} = useAppSelector(state => state.stripeKeysSlice);

    let stripePromise = null;

    if (gateway.publicKey) {
        stripePromise = loadStripe(gateway.publicKey);
    }

    return (
        <>
            {
                <Elements stripe={stripePromise}>
                    {children}
                </Elements>
            }
        </>
    )
}

export default StripeElements;